import { BasicInput } from '@elotech/components';
import { FieldProps, FormikProps } from 'formik';
import React from 'react';

type NumberListFieldProps = Omit<
  React.ComponentProps<typeof BasicInput>,
  'render' | 'hint'
>;

type Value = {
  raw: string;
  parsed: number[];
};

function parseNumberInput(input: string): number[] {
  if (!input) return [];

  const parts = input.split(',').map(p => p.trim());
  const numbers: number[] = [];

  for (const part of parts) {
    if (part.includes('-')) {
      const [startStr, endStr] = part.split('-').map(x => x.trim());
      const start = parseInt(startStr, 10);
      const end = parseInt(endStr, 10);

      if (!isNaN(start) && !isNaN(end) && start <= end) {
        for (let i = start; i <= end; i++) {
          numbers.push(i);
        }
      }
    } else {
      const num = parseInt(part, 10);
      if (!isNaN(num)) {
        numbers.push(num);
      }
    }
  }

  return Array.from(new Set(numbers)).sort((a, b) => a - b);
}

export const FormikNumberListField: React.FC<NumberListFieldProps> = props => {
  const handleChange = (
    form: FormikProps<any>,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;

    const regex = /^[0-9, -]+$/;
    if (value && !regex.test(value)) {
      return;
    }
    const parsed = parseNumberInput(value);
    form.setFieldValue(props.name, { raw: value, parsed });
  };

  return (
    <BasicInput
      {...props}
      hint="Para mais de um valor, utilize por exemplo: 1,2,3 e para um intervalo: 1-5"
      render={({ form, field }: FieldProps) => (
        <>
          <input
            id={props.name}
            value={(field.value as Value)?.raw}
            onChange={e => handleChange(form, e)}
            placeholder="Ex: 1,2,3,4-7,8"
          />
        </>
      )}
    />
  );
};
